<template>
  <div class="projectImageContainer">
    <img :src="imageSrc(imageSource)" :alt="caption" x="50%" y="50%" />
    <h4>{{ caption }}</h4>
  </div>
</template>

<script>
export default {
  name: "WorksImageContainer",
  props: {
    caption: String,
    imageSource: String
  },
  methods: {
    imageSrc: function(Str) {
      return require("@/assets/projectImages/" + Str);
    }
  }
};
</script>
<style lang="scss" scoped>
.projectImageContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 100%;
    display: block;
    object-fit: contain;
    overflow: hidden;
  }
  h4 {
    color: $mid-grey;
    text-align: center;
    font-size: 1.2rem;
    flex: 1;
    padding: 1.5rem 0rem;
  }
}
</style>
